export default {
    topics: [
        {
            title: ' GetAndTransform ',
            href: 'sm-content-GetAndTransform.html',
            attributes: { 'data-id': 'sm-content-GetAndTransform' },
            menu: { hasChildren: false },
            tocID: 'sm-content-GetAndTransform-d66e1997',
            topics: [],
        },
    ],
};

